import {
  PageLoadingStyles, LoaderWrap, OrbitRing, LoadingText,
} from './PageLoading.styles';

export default function PageLoading() {
  return (
    <PageLoadingStyles>
      <div className="d-flex content-loading">
        <LoaderWrap>
          <OrbitRing />
          <LoadingText>Attendere prego</LoadingText>
        </LoaderWrap>
      </div>
    </PageLoadingStyles>
  );
}
